import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { GestionnaireGuard } from '../core/guards/gestionnaire.guard';

export const RAPPORTS_ACTIVITE_ROUTES: Routes = [
  {
    path: 'reports/list',
    loadComponent: () =>
      import('../features/rapports-activite/list/list.component').then(
        (m) => m.RapportsActiviteListComponent
      ),
    canActivate: [AuthGuard, GestionnaireGuard]
  }
];
